import type { Id } from '../types';
import type { FoldStoreOptions, StoreModel } from './model';
import { compareIds } from './positions';

export interface SortableItem {
  itemId: Id;
  productId: Id | null;
  listIndex: number;
  /** Czas odhaczenia (ms) albo null, gdy pozycja czeka na odhaczenie. */
  checkedAt: number | null;
}

export interface SortedList<T> {
  /** „Gdzieś po drodze”: produkty bez wyuczonego miejsca w tym sklepie, w kolejności listy. */
  unknown: T[];
  /** Produkty w kolejności trasy. */
  known: T[];
  /** Odhaczone, najnowsze pierwsze. */
  done: T[];
}

export function sortList<T extends SortableItem>(
  model: StoreModel,
  items: readonly T[],
  opts: FoldStoreOptions = {},
): SortedList<T> {
  const resolve = opts.resolveProduct ?? ((id: Id) => id);
  const unknown: T[] = [];
  const known: { item: T; id: Id; pos: number }[] = [];
  const done: T[] = [];
  for (const item of items) {
    if (item.checkedAt !== null) {
      done.push(item);
      continue;
    }
    const id = item.productId === null ? null : resolve(item.productId);
    if (id === null || !Object.hasOwn(model.byProduct, id)) unknown.push(item);
    else known.push({ item, id, pos: model.byProduct[id]!.pos });
  }
  unknown.sort((a, b) => a.listIndex - b.listIndex);
  known.sort((a, b) => a.pos - b.pos || compareIds(a.id, b.id) || a.item.listIndex - b.item.listIndex);
  done.sort((a, b) => b.checkedAt! - a.checkedAt! || a.listIndex - b.listIndex);
  return { unknown, known: known.map((k) => k.item), done };
}
